export default {
    'modifyProfile.member_profile': '会員情報',
    'modifyProfile.error.modify_fail': '変更に失敗しました。もう一度お試しください。',
    'modifyProfile.error.different_phone_number': '以前と異なる電話番号を入力してください。',
    'modifyProfile.modify': '変更',
    'modifyProfile.submit': '変更申請',
} as Record<string, string>;